<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/settings/user">Users</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">First Name</label></b-col>
                            <b-col md="8"><p>{{ model.firstName }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Last Name</label></b-col>
                          <b-col md="8"><p>{{ model.lastName !== '' && model.lastName !== null ? model.lastName : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Leave Quota</label></b-col>
                          <b-col md="8 text-info"><p><b-badge pill variant="primary">{{ model.leaveQuota }}</b-badge></p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Username</label></b-col>
                          <b-col md="8"><p>{{ model.username }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Email</label></b-col>
                          <b-col md="8"><p>{{ model.email }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Branch</label></b-col>
                          <b-col md="8"><p>{{ model.branch }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Department</label></b-col>
                          <b-col md="8"><p>{{ model.department }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Address</label></b-col>
                          <b-col md="8"><p>{{ model.address }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Phone</label></b-col>
                          <b-col md="8"><p>{{ model.phone }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Role</label></b-col>
                          <b-col md="8"><p>{{ model.role }}</p></b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="mt-2">  
                    <b-tabs>
                      <template v-slot:tabs-end>
                        <b-nav-item @click="activeTab = 'Overtime'">Overtime</b-nav-item>
                        <b-nav-item @click="activeTab = 'Leave'">Leave</b-nav-item>
                        <b-nav-item @click="activeTab = 'Reimbursement'">Reimbursement</b-nav-item>
                      </template>

                      <div class="nav-content">
                        <div v-if="activeTab === 'Overtime'" key="overtime" class="nav-content-detail">
                          <div class="content-detail">
                            <paginated-table ref="dataTable" :canReject="false" :canApprove="false" :can-show="true" :can-show-route-path="'/overtime'" :can-delete="false" :can-edit="false" :data-url="apiUrl.overtime" :data-key="dataKey.overtime" :data-columns="columnsOvertime" :data-params="['requestedBy', 'overtime_type_uuid', 'start_date', 'end_date', 'requested_by', 'approved_by', 'rejected_by', 'status']">
                            </paginated-table>
                          </div>
                        </div>
                        <div v-if="activeTab === 'Leave'" key="leave" class="nav-content-detail">
                          <div class="content-detail">
                            <paginated-table ref="dataTable" :canReject="false" :canApprove="false" :can-show="true" :can-show-route-path="'/leave'" :can-delete="false" :can-edit="false" :data-url="apiUrl.leave" :data-key="dataKey.leave" :data-columns="columnsLeave" :data-params="['requestedBy', 'leave_type_uuid', 'start_date', 'end_date', 'requested_by', 'approved_by', 'rejected_by', 'status']">
                            </paginated-table>
                          </div>
                        </div>
                        <div v-if="activeTab === 'Reimbursement'" key="reimbursement" class="nav-content-detail">
                          <div class="content-detail">
                            <paginated-table ref="dataTable" :canReject="false" :canApprove="false" :can-show="true" :can-show-route-path="'/reimbursement'" :can-delete="false" :can-edit="false" :data-url="apiUrl.reimbursement" :data-key="dataKey.reimbursement" :data-columns="columnsReimbursement" :data-params="['requestedBy', 'reimbursement_type_uuid', 'start_date', 'end_date', 'requested_by', 'approved_by', 'rejected_by', 'status']">
                            </paginated-table>
                          </div>
                        </div>
                      </div>

                    </b-tabs>
                  </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
        </b-card>
    </div>
</template>

<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'user-details',
        components: {
          PaginatedTable
        },
        data () {
            return {
                actived: true,
                activeTab: "Overtime",
                isLoading: false,
                apiUrl: {
                    profile: window.AppConfig.apiUrl + 'profile',
                    leave : window.AppConfig.apiUrl + 'leave?requested_by='+this.$route.params.uuid+'',
                    overtime : window.AppConfig.apiUrl + 'overtime?requested_by='+this.$route.params.uuid+'',
                    reimbursement : window.AppConfig.apiUrl + 'reimbursement?requested_by='+this.$route.params.uuid+''
                },
                dataKey: {
                    overtime: 'overtime',
                    leave: 'leave',
                    reimbursement: 'reimbursement'
                },
                model: {
                    status: '',
                    note: '',
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    phone: '',
                    branch: '',
                    department: '',
                    role: '',
                    leaveQuota: '',
                    username: '',
                    isActive: true,
                },
                statusList: [
                    {
                        value: null,
                        text: 'All Status'
                    },
                    {
                        value: 'Requested',
                        text: 'Requested'
                    },
                    {
                        value: 'Approved',
                        text: 'Approved'
                    },
                    {
                        value: 'Rejected',
                        text: 'Rejected'
                    }
                ],
                columnsLeave: [
                    {
                        key: 'startDate',
                        label: 'Start Date',
                        sortable: true
                    },
                    {
                        key: 'endDate',
                        label: 'End Date',
                        sortable: true
                    },
                    {
                        key: 'days',
                        label: 'Days',
                        sortable: true
                    },
                    {
                        key: 'leaveType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                columnsOvertime: [
                    {
                        key: 'startTime',
                        label: 'Start Time',
                        sortable: true
                    },
                    {
                        key: 'endTime',
                        label: 'End Time',
                        sortable: true
                    },
                    {
                        key: 'hour',
                        label: 'Hour',
                        sortable: true
                    },
                    {
                        key: 'overtimeType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                columnsReimbursement: [
                    {
                        key: 'amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'reimburseType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ]
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.profile + '/' + this.$route.params.uuid).then(response => {
                  this.model.email = response.data.email !== null ? response.data.email : '-'
                  this.model.password = response.data.password !== null ? response.data.password : '-'
                  this.model.firstName = response.data.firstName !== null ? response.data.firstName : '-'
                  this.model.lastName = response.data.lastName !== null ? response.data.lastName : '-'
                  this.model.username = response.data.username !== null ? response.data.username : '-'
                  this.model.address = response.data.address !== null ? response.data.address : '-'
                  this.model.phone = response.data.phone !== null ? response.data.phone : '-'
                  this.model.branch = response.data.branch !== null ? response.data.branch.name : '-'
                  this.model.department = response.data.department !== null ? response.data.department.name : '-'
                  this.model.role = response.data.role !== null ? response.data.role : '-'
                  this.model.leaveQuota = response.data.leaveQuota !== null ? response.data.leaveQuota : '-'
                  this.model.isActive = response.data.isActive !== null ? response.data.isActive : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    break
                case 'Requested':
                    return 'info'
                    break
                case 'Rejected':
                    return 'danger'
                    break
                }
            }
        }
    }
</script>